module.exports = __webpack_public_path__ + "img/usa-cardiovascular-diseases-male.07377db7.png";